import config from '../../config';

export const generateCawiUrl = (surveyId) => `${config.cawiUrl}/survey/${surveyId}`;
export const generateFbMessengerUrl = (surveyId) => config.fbMessengerUrl.replace('%ID%', surveyId);
export const generateWhatsappUrl = (code) => config.whatsappUrl.replace('%CODE%', code);
